import { render } from "./OrderingRounds.vue?vue&type=template&id=4e1b30d2&scoped=true"
import script from "./OrderingRounds.vue?vue&type=script&lang=js"
export * from "./OrderingRounds.vue?vue&type=script&lang=js"

import "./OrderingRounds.vue?vue&type=style&index=0&id=4e1b30d2&scoped=true&lang=css"
import "./OrderingRounds.vue?vue&type=style&index=1&id=4e1b30d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1b30d2"]])

export default __exports__